import React, { useEffect, useLayoutEffect, useState } from "react";

import { StepContainer, NavigationButtons, InfoBox } from "../index";

import { useWizard } from "../../wizard";

import { contentApi } from "../../services/contentApi";

import { contentKeys } from "../../constants/contentKeys";

const formatDate = (dateStr: string) => {
  const [y, m, d] = dateStr.split("-").map(Number);

  const date = new Date(y, m - 1, d);

  const months = [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december",
  ];

  return `${d}. ${months[m - 1]} ${y}`;
};

const CancelConfirmationStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData } = useWizard();

  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi.getByKey(contentKeys.afbestil.bk_confirmation).then((c) => {
      if (c?.body && c.body.length > 0) {
        setBody(c.body);
      }
    });
  }, []);

  useLayoutEffect(() => {
    updateSelfServiceData("isCompleted", true);
  }, [updateSelfServiceData]);

  const { date, time, locationName, cancelBookingRef } = selfServiceData;

  return (
    <StepContainer title="Afbestilling gennemført">
      {body ? (
        <InfoBox type="success">
          {body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </InfoBox>
      ) : (
        <InfoBox type="success">
          <p>
            Din tid er nu afbestilt. Du modtager en bekræftelse på SMS/email.
          </p>
        </InfoBox>
      )}

      {(locationName || date || time || cancelBookingRef) && (
        <>
          <h3>Afbestilt tid</h3>

          <ul className="summary-list">
            {cancelBookingRef && (
              <li>
                <span className="label">Bookingreference</span>

                <span className="value">{cancelBookingRef}</span>
              </li>
            )}

            {locationName && (
              <li>
                <span className="label">Sted</span>

                <span className="value">{locationName}</span>
              </li>
            )}

            {date && (
              <li>
                <span className="label">Dato</span>

                <span className="value">{formatDate(date)}</span>
              </li>
            )}

            {time && (
              <li>
                <span className="label">Tid</span>

                <span className="value">kl. {time}</span>
              </li>
            )}
          </ul>
        </>
      )}

      <NavigationButtons showBack={false} showNext={false} />
    </StepContainer>
  );
};

export default CancelConfirmationStep;
